export const textDecorations = {
  overline: 'overline',
  underline: 'underline',
  strikethrough: 'line-through',
};
